import { Site } from '@debbie/common/dist/index.js';
import { useSelector } from 'react-redux';
// The creditor portal works on one creditor at a time — Authenticate only
// renders it once one is selected; the caseworker app spans the whole tenant.
export const useCreditorScope = () => {
    const site = useSelector((s) => s.site);
    const selectedCreditorId = useSelector((s) => s.selectedCreditor);
    const clientSite = site === Site.Client;
    return {
        clientSite,
        creditorId: clientSite && selectedCreditorId ? selectedCreditorId : undefined,
    };
};
//# sourceMappingURL=creditorScope.js.map